import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './Locale/en.json';
import translationFR from './Locale/fr.json';
import translationBG from './Locale/bg.json';
import translationCS from './Locale/cs.json';
import translationDA from './Locale/da.json';
import translationDE from './Locale/de.json';
import translationEL from './Locale/el.json';
import translationES from './Locale/es.json';
import translationFI from './Locale/fi.json';
import translationHU from './Locale/hu.json';
import translationID from './Locale/id.json';
import translationIT from './Locale/it.json';
import translationJA from './Locale/ja.json';
import translationKO from './Locale/ko.json';
import translationMS from './Locale/ms.json';
import translationNL from './Locale/nl.json';
import translationNO from './Locale/no.json';
import translationPL from './Locale/pl.json';
import translationPTBR from './Locale/pt-BR.json';
import translationPT from './Locale/pt.json';
import translationRO from './Locale/ro.json';
import translationRU from './Locale/ru.json';
import translationSK from './Locale/sk.json';
import translationSR from './Locale/sr.json';
import translationSV from './Locale/sv.json';
import translationTA from './Locale/ta.json';
import translationTH from './Locale/th.json';
import translationTR from './Locale/tr.json';
import translationVI from './Locale/vi.json';
import translationZHCHS from './Locale/zh-CHS.json';
import translationZHCHT from './Locale/zh-CHT.json';
import translationZH from './Locale/zh.json';

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  bg: {
    translation: translationBG,
  },
  cs: {
    translation: translationCS,
  },
  da: {
    translation: translationDA,
  },
  de: {
    translation: translationDE,
  },
  el: {
    translation: translationEL,
  },
  es: {
    translation: translationES,
  },
  fi: {
    translation: translationFI,
  },
  hu: {
    translation: translationHU,
  },
  id: {
    translation: translationID,
  },
  it: {
    translation: translationIT,
  },
  ja: {
    translation: translationJA,
  },
  ko: {
    translation: translationKO,
  },
  ms: {
    translation: translationMS,
  },
  nl: {
    translation: translationNL,
  },
  no: {
    translation: translationNO,
  },
  pl: {
    translation: translationPL,
  },
  'pt-BR': {
    translation: translationPTBR,
  },
  pt: {
    translation: translationPT,
  },
  ro: {
    translation: translationRO,
  },
  ru: {
    translation: translationRU,
  },
  sk: {
    translation: translationSK,
  },
  sr: {
    translation: translationSR,
  },
  sv: {
    translation: translationSV,
  },
  ta: {
    translation: translationTA,
  },
  th: {
    translation: translationTH,
  },
  tr: {
    translation: translationTR,
  },
  vi: {
    translation: translationVI,
  },
  'zh-CHS': {
    translation: translationZHCHS,
  },
  'zh-CHT': {
    translation: translationZHCHT,
  },
  zh: {
    translation: translationZH,
  },
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Use English if detected language is not available
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

export default i18n;